<template>
    <BaseSection
        v-if="featureFlag('cta-cards-list') && items.length"
        class="flexible-sections__section cta-cards-list"
    >
        <div class="cta-cards-list__wrapper">
            <BaseCardCtaCardsList
                v-for="item in items"
                :key="item.title"
                :uri="item.uri"
            >
                <template #title>{{ item.title }}</template>
                <template #default>{{ item.text }}</template>

                <template
                    v-if="item.image"
                    #image
                >
                    <BaseFigure
                        :src="item.image[0]?.url"
                        :alt="item.image[0]?.alt || ''"
                        :width="item.image[0]?.width"
                        :height="item.image[0]?.height"
                    />
                </template>
            </BaseCardCtaCardsList>
        </div>
    </BaseSection>
</template>

<script setup>
const { uriFromEntryFields } = useUri();
const { featureFlag } = useMultisite();

const props = defineProps({
    ctaCards: {
        type: Array,
        required: false,
        default: () => []
    }
});

const items = computed(() => {
    return props.ctaCards.map((ctaCards) => {
        return {
            title: ctaCards.title,
            text: ctaCards.text,
            image: ctaCards.image,
            uri: uriFromEntryFields(ctaCards)
        };
    });
});
</script>

<style lang="less">
.cta-cards-list {
    @media @q-lg-min {
        grid-column: -1/1 !important;/* stylelint-disable-line declaration-no-important */
        position: relative;
        margin-top: var(--spacing-section);
    }
}

.cta-cards-list__wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);

    @media @q-md-min {
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
        gap: .5rem;
    }
}
</style>
